import {
  Combine,
  Eye,
  List,
  Menu,
  Package,
  Plus,
  Printer,
  User,
  X,
} from 'lucide-react'
import { useState } from 'react'
import { toast } from 'react-toastify'
import apinode from '../../services/apinode'

const ModernOrdersNavbar = ({
  selectedOrders = [],
  setSelectedOrders, // agora vem do pai
  onUnifyOrders,
  onPrintLabels,
  isUnifyOrdersLoading,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [logs, setLogs] = useState([])

  // Imprimir etiquetas
  const handlePrintLabels = async () => {
    if (!selectedOrders.length) return

    setLoading(true)
    try {
      if (onPrintLabels) {
        await onPrintLabels(selectedOrders)
      } else {
        for (const order of selectedOrders) {
          const { SHIP, PEDIDO, SELLER } = order
          console.log('Enviando...', SELLER, SHIP, PEDIDO)

          try {
            const response = await apinode.get(
              `/pedido/shippinglabelsMl/${localStorage.idconta}`,
              { params: { seller: SELLER, shipping: SHIP, pedido: PEDIDO } },
            )

            console.log(response.data)
            setLogs((prev) => [
              ...prev,
              {
                success: true,
                message: `Pedido ${PEDIDO} impresso com sucesso`,
              },
            ])
          } catch (error) {
            const logMessage = `Erro ao imprimir pedido ${PEDIDO}: ${error.message}`
            setLogs((prev) => [
              ...prev,
              { success: false, message: logMessage },
            ])

            if (error.response && error.response.status === 500) {
              setLogs((prev) => [
                ...prev,
                {
                  success: false,
                  message: 'Erro 500: Ocorreu um erro interno do servidor.',
                },
              ])
              toast.error(
                'Ops!, Erro ao emitir etiquetas dos pedidos selecionados',
              )
            }
          }
        }
      }
      if (setSelectedOrders) setSelectedOrders([]) // limpar seleção
    } catch (error) {
      toast.error('Ops!, Erro ao emitir etiquetas dos pedidos selecionados')
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <style>{`
        .modern-navbar {
          background-color: #ffffff;
          border-bottom: 1px solid #e5e7eb;
          padding: 12px 24px;
          margin-bottom: 24px;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
          position: relative;
        }

        .navbar-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 1200px;
          margin: 0 auto;
        }

        .navbar-brand {
          margin: 0;
          color: #1f2937;
          font-weight: 600;
          font-size: 1.25rem;
        }

        .navbar-toggle {
          display: none;
          background-color: transparent;
          border: none;
          cursor: pointer;
          padding: 8px;
          border-radius: 6px;
          color: #6b7280;
        }

        .navbar-buttons {
          display: flex;
          gap: 4px;
          align-items: center;
          flex-wrap: wrap;
          max-width: 70%;
        }

        .navbar-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 6px 8px;
          border: none;
          border-radius: 4px;
          font-size: 11px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          text-decoration: none;
          min-height: 32px;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .navbar-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
        }

        .navbar-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
        }

        .btn-custom {
          background-color: #ff3200;
          color: white;
        }

        .btn-secondary {
          background-color: #6b7280;
          color: white;
        }

        .btn-success {
          background-color: #16a34a;
          color: white;
        }

        .btn-info {
          background-color: #0891b2;
          color: white;
        }

        .btn-dark {
          background-color: #374151;
          color: white;
        }

        .btn-primary {
          background-color: #2563eb;
          color: white;
        }

        .loading-spinner {
          width: 12px;
          height: 12px;
          border: 2px solid rgba(255,255,255,0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .mobile-menu {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background-color: white;
          border-top: 1px solid #e5e7eb;
          padding: 16px 24px;
          display: none;
          z-index: 1000;
        }

        .mobile-buttons {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .mobile-buttons .navbar-btn {
          width: 100%;
          justify-content: center;
        }

        @media (max-width: 1200px) {
          .navbar-btn {
            padding: 5px 6px;
            font-size: 10px;
            gap: 3px;
          }
          .navbar-buttons {
            gap: 3px;
            max-width: 75%;
          }
        }

        @media (max-width: 992px) {
          .navbar-buttons {
            display: none;
          }
          .navbar-toggle {
            display: block;
          }
          .mobile-menu.open {
            display: block;
          }
        }
      `}</style>

      <nav className="modern-navbar">
        <div className="navbar-container">
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <h5 className="navbar-brand">Gerenciar Pedidos</h5>
          </div>

          <button
            className="navbar-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <div className="navbar-buttons">
            <button
              className="navbar-btn btn-custom"
              disabled={selectedOrders.length < 2}
              onClick={onUnifyOrders}
            >
              {isUnifyOrdersLoading ? (
                <>
                  <div className="loading-spinner" />
                  Unificando...
                </>
              ) : (
                <>
                  <Combine size={12} />
                  Unificar
                </>
              )}
            </button>

            <button className="navbar-btn btn-secondary">
              <User size={12} />
              Alterar Status
            </button>

            <a
              href="/pedidos/PendingOrders"
              target="_blank"
              rel="noopener noreferrer"
              className="navbar-btn btn-dark"
            >
              <Package size={12} />
              Pendentes
            </a>

            <button
              className="navbar-btn btn-success"
              disabled={selectedOrders.length === 0}
              onClick={handlePrintLabels}
            >
              {loading ? (
                <>
                  <div className="loading-spinner" />
                  IMPRIMINDO...
                </>
              ) : (
                <>
                  <Printer size={12} />
                  Imprimir
                </>
              )}
            </button>

            <button className="navbar-btn btn-info">
              <Eye size={12} />
              NFE
            </button>

            <button className="navbar-btn btn-dark">
              <List size={12} />
              Log
            </button>

            <a
              href="/pedido/editar/novo"
              className="navbar-btn btn-primary"
            >
              <Plus size={12} />
              Novo
            </a>
          </div>
        </div>
      </nav>
    </>
  )
}

export default ModernOrdersNavbar
